// @ts-strict-ignore
import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from "primeng/table";
import { ProgressCheck } from "src/app/shared/models/progress-check.model";
import { SharedDirectivesModule } from "src/app/shared/shared-directives.module";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import { DataService } from "src/app/shared/services/data.service";
import * as ProfileModel from "src/app/shared/models/profile.model";

@Component({
  selector: C.EWIZ_REGULATORY_ECALL_SETUP_ECALL_ONLY,
  templateUrl: "./regulatory-ecall-support-setup-ecall-only.component.html",
  standalone: true,
  imports: [CommonModule, FormsModule, InputTextModule, TableModule, SharedDirectivesModule]
})
export class EWizRegulatoryECallSetupECallOnlyComponent extends EWizDynamicBaseClassComponent implements ProgressCheck {
  progressCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    if (values.regulatoryECallSupport) {
      for (const record of values.regulatoryECallSupport.eCallOnlyRecords) {
        if (dataService.isNullOrEmpty(record.displayName)) {
          return false;
        }
        if (dataService.isNullOrEmpty(record.dialingNumber)) {
          return false;
        }
      }
    } else {
      return false;
    }

    return true;
  }
}
